/* unplugin-vue-components disabled */import { render } from "./ReferenceTable2.vue?vue&type=template&id=41f186c6&scoped=true&ts=true"
import script from "./ReferenceTable2.vue?vue&type=script&lang=ts"
export * from "./ReferenceTable2.vue?vue&type=script&lang=ts"

import "./ReferenceTable2.vue?vue&type=style&index=0&id=41f186c6&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f186c6"]])

export default __exports__